module.exports = __webpack_public_path__ + "html/trade-ins.template.html";